module.exports = __webpack_public_path__ + "app/assets/images/footerbackground.png";


//////////////////
// WEBPACK FOOTER
// ./app/assets/images/footerbackground.png
// module id = 1121
// module chunks = 7